import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSprinklerIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 46,
	height: 40,
	viewBox: "0 0 46 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_14_2732)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M39.684 0H6.316C5.29015 0 4.45944 0.76461 4.45944 1.70884V3.11427C4.45944 4.0585 5.29015 4.82311 6.316 4.82311H11.382V7.23831C11.382 7.28928 11.3846 7.34025 11.3899 7.39123C11.3398 7.87427 11.5165 8.37187 11.9173 8.74325L14.0244 10.6827C14.7391 11.3405 15.8968 11.3405 16.6115 10.6827C17.3262 10.0249 17.3262 8.95928 16.6115 8.30148L15.0397 6.85479V4.82311H21.121V14.0009H17.6321C16.5165 14.0009 14.2644 16.0689 14.2644 17.0957C14.2644 18.1225 16.5165 17.819 17.6321 17.819H28.0884C29.2039 17.819 31.4561 18.1249 31.4561 17.0957C31.4561 16.0665 29.2039 14.0009 28.0884 14.0009H24.7814V4.82554H30.8627V6.62904L29.0431 8.3039C28.3284 8.96171 28.3284 10.0273 29.0431 10.6851C29.7577 11.3429 30.9154 11.3429 31.6301 10.6851L33.7372 8.74568C33.8559 8.63645 33.9561 8.51266 34.0352 8.38401C34.3358 8.08302 34.5231 7.68251 34.5231 7.24316V4.82796H39.6866C40.7125 4.82796 41.5432 4.06335 41.5432 3.11912V1.7137C41.5432 0.769464 40.7125 0.00485466 39.6866 0.00485466L39.684 0Z",
				fill: "{fill}"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.0577 21.9358C16.0577 21.9358 7.10713 23.482 10.7675 26.9871C13.9084 29.9945 16.0577 21.9358 16.0577 21.9358Z",
				fill: "{fill}"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.7788 21.6445C29.7788 21.6445 30.3985 30.0067 34.6075 27.0745C38.223 24.5573 29.7788 21.6445 29.7788 21.6445Z",
				fill: "{fill}"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.5958 31.9243C31.5958 31.9243 29.2092 40.0121 34.2304 38.5096C38.5421 37.2183 31.5958 31.9243 31.5958 31.9243Z",
				fill: "{fill}"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.2542 29.611C39.2542 29.611 42.2579 37.5241 45.4726 33.6695C48.2337 30.3611 39.2542 29.611 39.2542 29.611Z",
				fill: "{fill}"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.9163 32.1719C13.9163 32.1719 6.64036 37.211 11.6061 38.8592C15.8704 40.2743 13.9163 32.1719 13.9163 32.1719Z",
				fill: "{fill}"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.4264 22.4359C22.4264 22.4359 17.5872 29.5358 22.8668 29.4411C27.4001 29.3586 22.4264 22.4359 22.4264 22.4359Z",
				fill: "{fill}"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.4264 32.9948C22.4264 32.9948 17.5872 40.0947 22.8668 40C27.4001 39.9175 22.4264 32.9948 22.4264 32.9948Z",
				fill: "{fill}"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.17097 29.4921C6.17097 29.4921 -2.77955 31.0383 0.880826 34.5433C4.02169 37.5508 6.17097 29.4921 6.17097 29.4921Z",
				fill: "{fill}"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_14_2732",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 46,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgSprinklerIcon;
